import { useEffect } from "react";

const isMac = navigator.userAgent.includes("Mac");

interface KeyboardShortcut {
    key: string;
    handler: () => void;
    description: string;
}

export const useKeyboardShortcuts = (shortcuts: KeyboardShortcut[]) => {
    useEffect(() => {
        const handleKeyDown = (e: KeyboardEvent) => {
            const modifierKey = isMac ? e.metaKey : e.ctrlKey;

            for (const shortcut of shortcuts) {
                if (modifierKey && e.key.toLowerCase() === shortcut.key.toLowerCase()) {
                    e.preventDefault();
                    shortcut.handler();
                    break;
                }
            }
        };

        window.addEventListener("keydown", handleKeyDown);
        return () => window.removeEventListener("keydown", handleKeyDown);
    }, [shortcuts]);
};

export const getModifierKey = () => (isMac ? "⌘" : "Ctrl");
export const getShortcutText = (key: string) => `${getModifierKey()} + ${key.toUpperCase()}`;
